import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from './context/themecontext';

//import Login from './Admin/Login';
//import ForgotPassword from './Admin/ForgotPasswordPage';
//import ResetPassword from './Admin/ResetPasswordPage';
import AppLayout from './mmp';
import Dashboard from './md';
import Main from './main';
import MLogin from './mlogin';
import MResetPassword from './mResetPassword';
import MForgotPassword from './mForgotPassword';
import SalesRepPerformancePanel from './SalesRepPerformancePanel';
import LeadsTable from './leadsTable';
//import MSidebar from './msidebar';
//import MHeader from './mheader';
import SignInForm from './login';
import BarChartOne from './barchart';
import LineChartOne from './linechart';
import ChartTab from './chart';
import EcommerceMetrics from './infocards';
import MHome from './mdc';
import Settings from './Settings';
import Profile from './Profile';

function App() {
  const [appId, setappId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  


  useEffect(() => {
    const checkAuthentication = () => {
      // Only check for protected routes
      if (location.pathname.startsWith('/bb/app')) {
        const token = sessionStorage.getItem('token');
        
        if (!token) {
          // No token, redirect to login
          clearAuthData();
          navigate('/bb');
          setLoading(false);
          return;
        }
        
        // Token exists, allow access
        setLoading(false);
      } else {
        setLoading(false);
      }
    };
    
    const clearAuthData = () => {
      localStorage.removeItem('LoginData');
      sessionStorage.removeItem('userData');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('userId');
      sessionStorage.removeItem('appId');
      sessionStorage.removeItem('hubId');
      sessionStorage.removeItem('roleId');
      sessionStorage.removeItem('roleName');
      sessionStorage.removeItem('hubName');
      sessionStorage.removeItem('hubNumber');
      sessionStorage.removeItem('hubCity');
    };
    
    checkAuthentication();
  }, [navigate, location.pathname]);


  if (loading) {
    return <div>Loading...</div>;
  }

  const AccessDenied = () => {
    return (
      <div
        className="fixed inset-0 bg-gray-500/50 flex justify-center items-center"
        style={{ backdropFilter: 'blur(100px)' }}
        role="dialog"
        aria-modal="true"
      >
<div className="bg-white rounded shadow-md p-8 max-w-md">
  <h2 className="text-lg font-bold text-center">Access Denied</h2>
  <p className="text-gray-600 text-center">You do not have permission to access this page.</p>
  <div className="flex justify-center mt-2">
    <button
      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-1 rounded"
      onClick={() => {
        sessionStorage.clear();
        localStorage.clear();
        navigate('/bb');
      }}
    >
      Go Back
    </button>
  </div>
</div>
      </div>
    );
  };

  return (
          <ThemeProvider>
            <Routes>
          {/* <Route path="*" element={<AccessDenied />} />  */}
          <Route path="/mfr" element={<MLogin />}/>
          <Route path="/mfr/forgot-password" element={<MForgotPassword />} />
          <Route path="/mfr/reset-password/:resetToken" element={<MResetPassword />} />

          <Route path="/mfr/app" element={<Main />}>
              <Route path="mdc" element={<MHome />} />
              <Route path="salesrep" element={<SalesRepPerformancePanel />} />
              <Route path="leads" element={<LeadsTable />} />
              <Route path="profile" element={<Profile />} />
              <Route path="settings" element={<Settings />} />
          </Route>

            </Routes>
          </ThemeProvider>
  );
}

export default App;
